module.exports = __webpack_public_path__ + "static/media/soils_overview_1.1c614956.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_overview_1.png
// module id = 1286
// module chunks = 0